export function buildCategoryTree(categories) {
  const nodes = new Map();

  for (const category of categories) {
    nodes.set(category.id, { ...category, children: [] });
  }

  const roots = [];

  for (const category of categories) {
    const node = nodes.get(category.id);
    const parentId = category.parent_id;

    if (parentId && nodes.has(parentId)) {
      nodes.get(parentId).children.push(node);
    } else {
      roots.push(node);
    }
  }

  const sortNodes = (items) => {
    items.sort((a, b) => a.name.localeCompare(b.name, 'ru'));
    items.forEach((item) => sortNodes(item.children));
  };

  sortNodes(roots);
  return roots;
}

export function flattenCategoryTree(tree, depth = 0) {
  const items = [];

  for (const node of tree) {
    items.push({ id: node.id, name: node.name, depth });
    items.push(...flattenCategoryTree(node.children, depth + 1));
  }

  return items;
}

export function findCategoryNode(tree, categoryId) {
  for (const node of tree) {
    if (node.id === categoryId) {
      return node;
    }

    const found = findCategoryNode(node.children, categoryId);
    if (found) {
      return found;
    }
  }

  return null;
}

export function resolveCategoryFilterIds(categoryId, tree) {
  if (!categoryId) {
    return [];
  }

  const node = findCategoryNode(tree, categoryId);
  if (!node) {
    return [categoryId];
  }

  if (node.children.length === 0) {
    return [categoryId];
  }

  const ids = [];

  const collectChildren = (children) => {
    for (const child of children) {
      ids.push(child.id);
      if (child.children.length > 0) {
        collectChildren(child.children);
      }
    }
  };

  collectChildren(node.children);
  return ids;
}
